<template>
  <v-expansion-panels v-model="panel">
    <v-expansion-panel>
      <v-expansion-panel-header>
        <v-col cols="12" md="1">
          <v-icon color="primary">mdi-filter</v-icon
          ><span class="primary--text">
            {{ $t("filter") }}
          </span>
        </v-col>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" v-if="showSearchFilter">
              <v-text-field
                label="Name"
                outlined
                v-model="search"
                :prepend-inner-icon="'mdi-magnify'"
                @keypress.enter="handleFilter('search')"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch
                label="Active"
                v-model="active"
                false-value="no"
                true-value="yes"
                @change="handleFilter('active')"
              ></v-switch>
            </v-col>

            <!-- <v-col cols="12" md="1" class="align-self-center">
            <v-btn
              @click="handleFilter"
              :disabled="validFitler"
              class="primary"
            >
              <v-icon left>mdi-filter</v-icon>
              Filter
            </v-btn>
          </v-col> -->
            <v-col v-if="validQuery" cols="12" md="1" class="align-self-center">
              <v-btn @click="clearFilter" class="error">
                <v-icon left>mdi-squeegee</v-icon>
                Clear
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { isEqual } from "lodash";

export default {
  name: "GenericFilter",
  props: {
    showSearchFilter: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      panel: 0,
      search: "",
      active: "no",
      validQuery: false
    };
  },
  methods: {
    handleFilter(queryName) {
      const query = {};
      query[queryName] = this[queryName];
      if (!isEqual(query, this.$route.query)) {
        this.$router.push({ query: { ...this.$route.query, ...query } });
      }
    },
    clearFilter() {
      this.search = "";
      this.active = "no";
      const queries = ["search", "active"];
      const query = { ...this.$route.query };
      Object.keys(query).forEach(key => {
        if (queries.includes(key)) {
          this.$delete(query, key);
        }
      });
      this.$router.push({ query });
    }
  },

  watch: {
    $route: {
      handler({ query }) {
        if (query.search) this.search = query.search;
        if (query.active) this.active = query.active;
        if (Object.keys(query).length > 0) {
          this.validQuery = true;
        } else {
          this.validQuery = false;
        }
      },
      immediate: true
    }
  }
};
</script>
